export default "__VITE_ASSET__pLnthiN7__"